import { gql } from '@apollo/client';

export const CHANGE_DELIVERY_TASK_DRIVER = gql`
  mutation ChangeDeliveryTaskDriver($taskId: Long!, $newDriverAccountId: Long!, $taskDate: String!) {
    changeDeliveryTaskDriver(taskId: $taskId, newDriverAccountId: $newDriverAccountId, taskDate: $taskDate) {
      id
      originalDriverId
      driverAccountId
      status
      updatedAt
      __typename
    }
  }
`;
